import { render, staticRenderFns } from "./centered.vue?vue&type=template&id=39f91955"
import script from "./centered.vue?vue&type=script&lang=js"
export * from "./centered.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports